import { render } from "./HeroiconsSolidCreditCard.vue?vue&type=template&id=260d5666"
const script = {}

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCreditCard.vue"]])

export default __exports__